import httpService from '@/core/http-service'
import { filter } from 'lodash'

const state = {
  downloads: null,
  filter: ''
}

const mutations = {
  set_downloads(state, payload) {
    state.downloads = payload
  },
  set_filter(state, payload) {
    state.filter = payload
  }
}

const actions = {
  async getDownloads({ commit }) {
    const response = await httpService.get('downloads')
    commit('set_downloads', response.data)
  },
  async addNewDownload({ dispatch }, payload) {
    const { format } = typeof payload === 'string' ? { name: payload, format: 'xlsx' } : payload
    await httpService.post('downloads/addPriceList', { format })
    // Reload downloads after requesting a new one
    await dispatch('getDownloads')
  },
  async setPriceListConsentGdpr({ commit }) {
    const response = await httpService.post('downloads/confirmPriceListConsent')
    commit('set_downloads', response.data)
  },
  setFilter({ commit }, filterValue) {
    commit('set_filter', filterValue)
  }
}

const getters = {
  downloads: state => state.downloads,
  filter: state => state.filter,
  filteredDownloads: state => {
    if (!state.downloads.priceLists) return []
    if (!state.filter) return state.downloads.priceLists
    return filter(state.downloads.priceLists, download => download.name.toLowerCase().includes(state.filter.toLowerCase())
    )
  },
  downloadsIsLocked(state) {
    return state.downloads && !state.downloads.isPriceListConsentGiven && state.downloads.hasPriceListData
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
